<template>
    <div>
        <sweet-modal icon="success" ref="successMdal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>
            <small class="text-center w-100 mt-3">
                Successfully Saved
            </small>
        </sweet-modal>
    </div>
</template>

<script>
    import { EventBus } from '../../event/event-bus.js';

    export default {
        created() {
            EventBus.$on('emit-success', () => {
                this.$refs.successMdal.open();
            });
        },
    };
</script>
